import React, { useState } from "react";
import { Outlet, NavLink } from "react-router-dom";
import {
  FiLayout,
  FiFileText,
  FiMessageSquare,
  FiChevronLeft,
  FiChevronRight,
  FiBarChart2,
  FiPieChart,
  FiUsers,
  FiUserPlus,
} from "react-icons/fi";

const Admin = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Left Sidebar */}
      <div
        className={`bg-white shadow-lg flex flex-col transition-all duration-300 ${
          isCollapsed ? "w-20" : "w-64"
        }`}
      >
        <div className="p-6 border-b flex items-center justify-between">
          {!isCollapsed && (
            <h2 className="text-xl font-bold text-gray-800">Admin Panel</h2>
          )}
          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors text-gray-600 hover:text-gray-800"
            aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            {isCollapsed ? (
              <FiChevronRight className="w-5 h-5" />
            ) : (
              <FiChevronLeft className="w-5 h-5" />
            )}
          </button>
        </div>

        <nav className="flex flex-col gap-2 p-4">
          <NavLink
            to="/asjkaska2222/admin/admin-dashboard"
            className={({ isActive }) =>
              `flex items-center ${
                isCollapsed ? "justify-center" : "gap-3"
              } px-4 py-3 rounded-xl transition-colors ${
                isActive
                  ? "bg-primary text-white"
                  : "text-gray-700 hover:bg-gray-100"
              }`
            }
            title={isCollapsed ? "Dashboard" : ""}
          >
            <FiLayout className="w-5 h-5 flex-shrink-0" />
            {!isCollapsed && <span className="font-medium">Dashboard</span>}
          </NavLink>

          <NavLink
            to="/asjkaska2222/admin/admin-questions"
            className={({ isActive }) =>
              `flex items-center ${
                isCollapsed ? "justify-center" : "gap-3"
              } px-4 py-3 rounded-xl transition-colors ${
                isActive
                  ? "bg-primary text-white"
                  : "text-gray-700 hover:bg-gray-100"
              }`
            }
            title={isCollapsed ? "Questions" : ""}
          >
            <FiFileText className="w-5 h-5 flex-shrink-0" />
            {!isCollapsed && <span className="font-medium">Questions</span>}
          </NavLink>

          <NavLink
            to="/asjkaska2222/admin/admin-feedback"
            className={({ isActive }) =>
              `flex items-center ${
                isCollapsed ? "justify-center" : "gap-3"
              } px-4 py-3 rounded-xl transition-colors ${
                isActive
                  ? "bg-primary text-white"
                  : "text-gray-700 hover:bg-gray-100"
              }`
            }
            title={isCollapsed ? "Feedback" : ""}
          >
            <FiMessageSquare className="w-5 h-5 flex-shrink-0" />
            {!isCollapsed && <span className="font-medium">Feedback</span>}
          </NavLink>

          <NavLink
            to="/asjkaska2222/admin/admin-qb-summary"
            className={({ isActive }) =>
              `flex items-center ${
                isCollapsed ? "justify-center" : "gap-3"
              } px-4 py-3 rounded-xl transition-colors ${
                isActive
                  ? "bg-primary text-white"
                  : "text-gray-700 hover:bg-gray-100"
              }`
            }
            title={isCollapsed ? "QB Summary" : ""}
          >
            <FiBarChart2 className="w-5 h-5 flex-shrink-0" />
            {!isCollapsed && <span className="font-medium">QB Summary</span>}
          </NavLink>

          <NavLink
            to="/asjkaska2222/admin/admin-item-analysis"
            className={({ isActive }) =>
              `flex items-center ${
                isCollapsed ? "justify-center" : "gap-3"
              } px-4 py-3 rounded-xl transition-colors ${
                isActive
                  ? "bg-primary text-white"
                  : "text-gray-700 hover:bg-gray-100"
              }`
            }
            title={isCollapsed ? "Item Analysis" : ""}
          >
            <FiPieChart className="w-5 h-5 flex-shrink-0" />
            {!isCollapsed && <span className="font-medium">Item Analysis</span>}
          </NavLink>

          <NavLink
            to="/asjkaska2222/admin/admin-student-activity"
            className={({ isActive }) =>
              `flex items-center ${
                isCollapsed ? "justify-center" : "gap-3"
              } px-4 py-3 rounded-xl transition-colors ${
                isActive
                  ? "bg-primary text-white"
                  : "text-gray-700 hover:bg-gray-100"
              }`
            }
            title={isCollapsed ? "Student Activity" : ""}
          >
            <FiUsers className="w-5 h-5 flex-shrink-0" />
            {!isCollapsed && (
              <span className="font-medium">Student Activity</span>
            )}
          </NavLink>

          <NavLink
            to="/asjkaska2222/admin/admin-create-user"
            className={({ isActive }) =>
              `flex items-center ${
                isCollapsed ? "justify-center" : "gap-3"
              } px-4 py-3 rounded-xl transition-colors ${
                isActive
                  ? "bg-primary text-white"
                  : "text-gray-700 hover:bg-gray-100"
              }`
            }
            title={isCollapsed ? "Create User" : ""}
          >
            <FiUserPlus className="w-5 h-5 flex-shrink-0" />
            {!isCollapsed && <span className="font-medium">User</span>}
          </NavLink>
        </nav>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default Admin;
